import db from "../firebase/firebase";
import firebase from "firebase";
import { makeId } from "./Helpers.js";

/**
 * Class containing any logic related to the creation and maintenance of room invitations
 */
export default class RoominvitationService {


  /**
   * Attempt to fetch a roominvitation document based on a given Id
   * returns null if roominvitation doesnt exist or on error
   *
   * @param invitationId
   * @return roominvitation|null
   */
  getInvitationById(invitationId) {
    let invitationRef = db.collection("roominvitations").doc(invitationId);
    return invitationRef.get()
  }


  /**
   * Prepare and return an object representing the current active roominvitation for the given channel
   *
   * @param invitationUid
   * @returns {Promise<{uid: *, isValid: *, id: *, channelId: *}>}
   */
  async getInvitationByUid(invitationUid) {
    let inviteData = null;
    return await db.collection("roominvitations")
      .where('uid', '==', invitationUid).limit(1)
      .get()
      .then(function(querySnapshot) {
        if (!querySnapshot.empty) {
          inviteData = querySnapshot.docs[0].data()
        }
        return !querySnapshot.empty
          ? {
            id: querySnapshot.docs[0].id ,
            uid: inviteData.uid,
            channelId: inviteData.channelId,
            isValid: inviteData.isValid
          }
        : null
      })
  }


  /**
   * Fetch the inviting channel for the given roominvitation
   *
   * @param invitation
   */
  getInvitingChannel(invitation) {
    let channelRef = db.collection("channels").doc(invitation.data().channelId);
    channelRef.get()
      .then((doc) => {
        return doc.exists ? doc : null
      }).catch((error) => {
      return null;
    });
  }


  /**
   * Attempt to fetch an active roominvitation for the given roomId
   *
   * @param roomId
   * @returns {Promise<*|void>}
   */
  async getActiveInvitationUidForRoomId(roomId) {
    return await db.collection("/roominvitations")
      .where('channelId', '==', roomId)
      .where('isValid', '==', true)
      .limit(1)
      .get()
      .then(function (querySnapshot) {
        return !querySnapshot.empty ? querySnapshot.docs[0].data().uid : null;
      })
      .catch(function (error) {
        console.error(error);
      });
  }


  /**
   * revoke any existing invitations, and create/persist a new invitation for the given room
   *
   * @param roomId
   * @return bool (success|fail)
   */
  async createNewInvitationForRoomId(roomId) {

    // todo: consider the need to automatically revoke existing links here.
    // this.revokeInvitationsForChannel(roomId)
    const uid = makeId(15)

    db.collection("roominvitations").add({
      channelId: roomId,
      isValid: true,
      uid: uid,
      createdAt: firebase.database.ServerValue.TIMESTAMP,
    })
    return uid

  }


  /**
   * Update an existing invitation marking it as invalid
   *
   * @param invitationId string
   * @return bool (success|fail)
   */
  async revokeInvitationsForChannel(channelId) {
    const query = db.collection("roominvitations").where('channelId', '==', channelId);
    query.get(query).then(function(result) {
      result.docs.forEach(function(doc){
        doc.ref.update({isValid: false})
      })
    })
  }


  /**
   * Retrieve the invitation identified by invitationId and add the user to the associated room.
   *
   * @param user obj (a valid user object, expected to be the currently authenticated user in most cases)
   * @param channelId
   */
  addUserToRoomById(user, channelId) {

    const channelDocRef = db.collection("channels").doc(channelId);
    channelDocRef
      .update({
        channelUsers: firebase.firestore.FieldValue.arrayUnion(user.uid),
      })
      .then(function () {
        console.log("User successfully added!");
      })
      .catch(function (error) {
        console.error("Error adding user: ", error);
      });

    return true;
  }


  /**
   * Send an existing invitation link via email
   *
   * @param invitation obj
   * @return bool (success|fail)
   */
  sendInvitationByEmail(invitation) {
    return true;
    //todo: send email...
  }



}
